import React from "react";

const PageTitle = ({ title }) => {
  return (
    <div className="mb-4">
      <h1 className="text-[32px] font-medium text-[#404040] font-inter">
        {title || "Untitled Page"}
      </h1>
    </div>
  );
};

export default PageTitle;
